import { memo } from 'react';

import { type OnboardingStep } from '@/entities/onboarding';

import { SubscriptionOnboardingStep } from './steps/subscription-onboarding-step';
import { TradingLevelOnboardingStep } from './steps/trading-level-onboarding-step';
import { UsernameAndPhoneOnboardingStep } from './steps/username-and-phone-onboarding-step';

interface OnboardingStepRendererProps {
    step: OnboardingStep;
    onNext?: ((stepSlug?: string) => void) | undefined;
    isLastStep?: boolean | undefined;
    isProcessing?: boolean | undefined;
    renderPlanSelector?: (() => React.ReactNode) | undefined;
}

export const OnboardingStepRenderer = memo(
    (props: OnboardingStepRendererProps) => {
        const { step, onNext, isLastStep, isProcessing, renderPlanSelector } =
            props;

        // Render specific components based on slug
        switch (step.slug) {
            case 'username_and_phone':
                return (
                    <UsernameAndPhoneOnboardingStep
                        isLastStep={isLastStep}
                        isProcessing={isProcessing}
                        onNext={() => onNext?.(step.slug)}
                        step={step}
                    />
                );
            case 'trading_level':
                return (
                    <TradingLevelOnboardingStep
                        isLastStep={isLastStep}
                        isProcessing={isProcessing}
                        onNext={() => onNext?.(step.slug)}
                        step={step}
                    />
                );
            case 'subscription':
                return (
                    <SubscriptionOnboardingStep
                        renderPlanSelector={renderPlanSelector}
                    />
                );
            default:
                return null;
        }
    },
);

OnboardingStepRenderer.displayName = 'OnboardingStepRenderer';
